import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Hero } from '../components/Hero';
import { Newsletter } from '../components/Newsletter';
import { SponsorSection } from '../components/SponsorSection';
import { EventListingsPreview } from '../components/EventListingsPreview';
import { CookieFeatureBlock } from '../components/CookieFeatureBlock';
import { Link } from 'react-router-dom';

export const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>{'World Soccer Party | Find World Soccer 2026 Viewing Events in Canada, USA & Mexico'}</title>
        <meta name="description" content="Join World Soccer Party, the ultimate hub for fans and venues. Find match-day events, exclusive fan cards, and the best local soccer atmospheres." />
        <meta name="description" content="The fan-curated guide to World Soccer 2026 viewing parties, fan zones, and events across North America. Find the best spots near you." />
        <meta property="og:title" content="World Soccer Party — World Soccer 2026 Viewing Events" />
        <meta property="og:description" content="Find World Soccer 2026 viewing parties, fan zones, and events across Canada, USA & Mexico." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Hero />
      <EventListingsPreview />
      <CookieFeatureBlock />

      {/* Refer a Venue / Refer an Event CTA */}
      <section className="py-12 bg-gradient-to-r from-orange-50 via-white to-orange-50" data-testid="refer-venue-section">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="font-['Bebas_Neue'] text-3xl sm:text-4xl uppercase text-gray-900 mb-3">Know a Spot That Should Be Here?</h2>
          <p className="text-gray-600 text-sm sm:text-base mb-6 max-w-xl mx-auto">
            If your favourite bar, restaurant or venue is hosting an event worth mentioning on World Soccer Party, let them know.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/refer-venue" className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-7 py-3.5 rounded-full font-bold text-sm uppercase tracking-wider hover:bg-[#FF8C42] shadow-lg hover:shadow-xl transition-all" data-testid="refer-venue-cta">
              Refer a Venue
            </Link>
            <Link to="/refer-event" className="inline-flex items-center gap-2 bg-white text-[#FF6B35] border-2 border-[#FF6B35] px-7 py-3.5 rounded-full font-bold text-sm uppercase tracking-wider hover:bg-[#FF6B35] hover:text-white shadow-lg hover:shadow-xl transition-all" data-testid="refer-event-cta">
              Refer an Event
            </Link>
          </div>
        </div>
      </section>

      <Newsletter />
      {/* (Msg 781) SponsorSection removed — Charity Partner block merged into
          the Newsletter row above; discovery inquiries route via /partnerships. */}
    </div>
  );
};
